import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import {CurrencyFormatter, DateFormatter, ProductColumn} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import ComponentConfig from "../../form/ComponentConfig";
import MoneyTransferForm from "./MoneyTransferForm";
import TextArea from "../../form/TextArea";
import DetailsButton from "../../form/DetailsButton";
import classNames from "classnames";

class PaymentFormComp extends React.Component {

    render() {
        const sortable = true;
        const filterable = true;
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Tranz. sz." role="idfield"/>
                    </div>
                    <div className="col-md-4 currency">
                        <TextInput
                            name="amount"
                            value={this.props.values.amount}
                            formatter={CurrencyFormatter}
                            label={(this.props.values.reversal || "1") === "1" ? "Fizetendő" : "Visszatérítés"}
                            disabled={this.props.disabled || (this.props.values.reversal || "1") === "-1"}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className={classNames({"col-md-6": this.props.businessComponent, "col-md-3": !this.props.businessComponent})}>
                        <Select
                            objectValue={false}
                            optionname="paymentprovider"
                            storeType="local"
                            name="serviceprovider_type"
                            value={(this.props.values && this.props.values.serviceprovider_type) || null}
                            label="Fizetés módja"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("serviceprovider_type")}
                            disabled={this.props.disabled}
                        />
                    </div>
                    {!this.props.businessComponent && <div className="col-md-3">
                        <div className="form-group">
                            <DetailsButton
                                component_type={this.props.values.component_type}
                                component_id={this.props.values.component_id}
                            />
                        </div>
                    </div>}
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            objectValue={false}
                            optionname="PaymentStatus"
                            storeType="local"
                            name="state"
                            value={(this.props.values && this.props.values.state) || null}
                            label="Állapot"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("state")}
                            disabled={true}
                        />
                    </div>
                    <div className="col-md-6">
                        <Select
                            objectValue={false}
                            optionname={((this.props.values && this.props.values.serviceprovider_type) || "None") + "Status"}
                            storeType="local"
                            name="status"
                            value={(this.props.values && this.props.values.status) || null}
                            label="Státusz"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("status")}
                            disabled={true}
                        />
                    </div>
                </div>
                {/*this.props.values.serviceprovider_type === "Transfer" && (this.props.values.reversal || "1") === "-1" && this.props.stateType.initiated(this.props.values.state) ? <ComponentConfig componentName="Transfer">
                    {(props) => <div className="row form-row">
                        <div className="col-md-12">
                            <ComponentConfig componentName="MoneyTransfer">
                                <MoneyTransferForm
                                    moneyrepositoryType="BankAccount"
                                    values={this.props.reverseAccept}
                                    setFieldValue={this.props.setReverseValue}
                                    getFieldProps={(field) => {
                                        const props = this.props.getFieldProps(field);
                                        props.disabled = props.disabled || field === "reversal" || field === "amount";
                                        return props;
                                    }}
                                />
                            </ComponentConfig>
                        </div>
                    </div>}
                </ComponentConfig> : null*/}
                {this.props.values.serviceprovider_type === "DelayedPayment" ? <Fragment>
                    <div className="row form-row">
                        <div className="col-md-6">
                            <Select
                                objectValue={false}
                                optionname="paymentprovider"
                                storeType="local"
                                name="payment.serviceprovider_type"
                                value={(this.props.values && (this.props.values.payment || {}).serviceprovider_type) || null}
                                label="Utólagos fizetés módja"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("payment.serviceprovider_type")}
                                disabled={this.props.disabled}
                            />
                        </div>
                        <div className="col-md-6">
                            <TextInput
                                name="confirmation_sent"
                                value={this.props.values.confirmation_sent}
                                label="Fizetési értesítő kiküldésének ideje"
                                saveChanges={this.props.setFieldValue}
                                formatter={DateFormatter}
                                {...this.props.getFieldProps("confirmation_sent")}
                                disabled="disabled"
                            />
                        </div>
                    </div>
                    {this.props.values.scheduled_at && <div className="row form-row">
                        <div className="col-md-12">
                            <TextInput
                                name="scheduled_at"
                                value={this.props.values.scheduled_at}
                                label="Esedékes"
                                saveChanges={this.props.setFieldValue}
                                formatter={DateFormatter}
                                {...this.props.getFieldProps("scheduled_at")}
                                disabled="disabled"
                            />
                        </div>
                    </div>}
                </Fragment> : null}
                {this.props.values.serviceprovider_type === "VoucherPayment" ? <div className="row form-row">
                        <div className="col-md-12">
                            <label className="control-label">Utalványok</label>
                            {
                                this.props.values[this.props.componentConfig.idfield]
                                &&
                                this.props.values.serviceprovider_id
                                ?
                                    <SelectorGrid
                                        ref={(voucherList) => this.voucherList = voucherList}
                                        {...this.props.getFieldProps("vouchers")}
                                        disabled={this.props.disabled}
                                        name="vouchers"
                                        listfieldlabel="displayname"
                                        aggregations={{
                                            fields: {
                                                "amount": {
                                                    field: "amount", type: "SUM"
                                                }
                                            }
                                        }}
                                        addRowProps={{
                                            filter: [
                                                {
                                                    field: "sold",
                                                    operator: "not isnull"
                                                },
                                                {
                                                    field: "used",
                                                    operator: "isnull"
                                                }
                                            ]
                                        }}
                                        columns={{
                                            "displayname": {header: 'Utalvány', width: 3, sortable, filterable},
                                            "barcode": {header: 'Vonalkód', width: 3, sortable, filterable},
                                            "amount": {header: 'Összeg', width: 3, sortable, filterable, renderer: CurrencyFormatter},
                                        }}
                                        data={{[this.props.serviceProviderConfig.idfield]: this.props.values.serviceprovider_id}}
                                        component="VoucherPayment"
                                        orderBy={{field: "displayname", direction: "ASC"}}
                                    />
                                :
                                    <Fragment>Kérlek mentsd el az utalványok megadása előtt!</Fragment>
                            }
                        </div>
                    </div> : null}
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextArea
                            {...this.props.getFieldProps("comment.text")}
                            name="comment.text"
                            value={(this.props.values.comment || {}).text}
                            label="Megjegyzés"
                            saveChanges={this.props.setFieldValue}
                            disabled={this.props.disabled}
                            {...this.props.getFieldProps("comment.text")}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

const PaymentForm = (props) => {
    if (props.values.serviceprovider_type) {
        return <ComponentConfig componentName={props.values.serviceprovider_type} componentConfigAs="serviceProviderConfig">
            <PaymentFormComp {...props} />
        </ComponentConfig>
    } else {
        return <PaymentFormComp {...props} />;
    }
}

export default createForm(PaymentForm);
